<section class="auction-dashboard-bidder mb-3">
  <div class="container-fluid">
    <div class="card auction-content-main m-0">
      <div class="auction-content-header p-4">
        <h4 class="fs-lg text-uppercase color-ashen-med">bidders</h4>
      </div>
      <div class="auction-content-body px-4 pb-4 pt-2">
        <div class="row mx-n2">
          <div [ngClass]="winnerList.length ? 'col-md-8' : 'col-12'">
            <div class="row">
              <div class="col-12">
                <app-live-auction></app-live-auction>
              </div>
            </div>
          </div>
          <div
            class="
              col-md-4 col-xl-4
              px-2
              winnerList
              d-flex
              flex-column
              boxShadow
            "
            *ngIf="winnerList.length"
          >
            <h3 class="fs-md ml-2 mt-2 mb-3 color-ashen-med">Winners List</h3>
            <div class="auction-bidders-listWrap auto-scroll">
              <ul class="auction-bidders-list list-unstyled">
                <li
                  class="auction-bidders-item"
                  *ngFor="let auctionItem of winnerList"
                >
                  <a
                    [routerLink]="[
                      '/auction-details',
                      auctionItem['auction_id']
                    ]"
                    routerLinkActive="router-link-active"
                    class="auction-bidders"
                  >
                    <div class="auction-bidders-personalThumb mr-2">
                      <img
                        src="{{ env }}assets/img/user-placeholder.png"
                        alt=""
                        class="auction-bidders-personalThumbImage"
                      />
                    </div>
                    <div class="auction-bidders-rankInfo">
                      <h4 class="fs-md fw-600 color-dark mb-0">
                        {{ auctionItem?.["user_details"]?.['first_name'] + ' ' +
                        (auctionItem?.["user_details"]?.['last_name'] ? auctionItem?.["user_details"]?.['last_name'] : '')}}
                      </h4>
                      <p class="mb-0">
                        Winning bid:
                        {{
                          auctionItem["winning_bid_amount"] | number: "1.0-2"
                        }}
                      </p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- <section class="auction-dashboard-charts">
  <div class="container-fluid">
    <div class="card auction-content-main m-0">
      <div class="auction-content-header p-4">
        <h4 class="fs-lg text-uppercase color-ashen-med">PRODUCT POPULARITY</h4>
      </div>
      <div class="auction-content-body px-4 pb-4 pt-2">
        <div class="row mx-n2 mb-4">
          <div class="col-sm-4 col-md-5 px-2">
            <form action="" class="credential4 popularity-filter">
              <div class="form-group">
                <select name="popularity" class="credential4__select form-control">
                  <option value="Top">Top</option>
                </select>
              </div>
            </form>
          </div>

          <div class="col-sm-8 col-md-7 px-2">
            <form action="" class="credential4 chart-filter-form">
              <div class="row mx-n2">
                <div class="col-md-6 px-2">
                  <div class="form-group mb-md-0">
                    <div class="credential4__input-group">
                      <span class="credential4__icon">
                        <img src="{{ env }}assets/img/sidebar/icons8-calendar.svg" alt="" />
                      </span>
                      <input type="text" name="dateRange" id="auction-bids-dateRange"
                        class="credential4__icon-input form-control" placeholder="From - To" [bsConfig]="{
                          rangeInputFormat: 'DD MMM YYYY',
                          dateInputFormat: 'DD MMM YYYY'
                        }" bsDaterangepicker readonly />
                    </div>
                  </div>
                </div>
                <div class="col-md-6 px-2">
                  <div class="input-group credential4__input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="las la-clock ion-2x color-dark"></i>
                      </span>
                    </div>
                    <input type="text" name="time_start" id="auction-bids-timeStart"
                      class="credential4__input form-control" placeholder="From" [ngxTimepicker]="bidTimeStart"
                      readonly />
                    <input type="text" name="time_end" id="auction-bids-timeEnd" class="credential4__input form-control"
                      placeholder="To" [ngxTimepicker]="bidTimeEnd" readonly />
                  </div>
                  <ngx-material-timepicker #bidTimeStart></ngx-material-timepicker>
                  <ngx-material-timepicker #bidTimeEnd></ngx-material-timepicker>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-md-6 px-2">
            <div class="auction-dashboard-chart mb-3 mb-md-0">
              <canvas baseChart [datasets]="doughnutChartData" [labels]="doughnutChartLabels"
                [chartType]="doughnutChartType">
              </canvas>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div class="auction-dashboard-chart">
              <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
                [legend]="true" [chartType]="barChartType">
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->
<app-loader *ngIf="loading"></app-loader>
